import { createApp } from 'vue'
import App from './App.vue'
import { createMetaManager } from 'vue-meta' // Forma correta para Vue 3
import router from './router'
import { createI18n } from 'vue-i18n'
// Instancia o gerenciador de meta
const metaManager = createMetaManager()
const savedLang = localStorage.getItem('lang')

const browserLang = navigator.language.startsWith('pt') ? 'pt' : 'en'

const locale = savedLang || browserLang

const i18n = createI18n({
  legacy: false,
  locale: locale,
  fallbackLocale: 'en',
})

createApp(App)
  .use(i18n)
  .use(router)
  .use(metaManager) // Usa o meta manager
  .mount('#app')
